export const colors = {
  primary: {
    main: "#E8A33D",
    hover: "#D8922E",
    active: "#B8741F",
  },

  accent: {
    main: "#F6C56F",
    hover: "#EAB14A",
    soft: "#FFD89A",
    subtle: "rgba(232, 163, 61, 0.15)",
  },

  background: {
    base: "#0A0A0F",
    dark: "#050507",
    surface: "#111114",
    card: "#15151B",
  },

  text: {
    primary: "#F5F5F5",
    secondary: "#B0B0B8",
    muted: "#73737D",
    contrast: "#2A1605",
  },

  border: {
    subtle: "rgba(255,255,255,0.05)",
    default: "rgba(255,255,255,0.08)",
    focus: "#E8A33D",
  },

  state: {
    success: {
      main: "#22C55E",
      hover: "#16A34A",
    },

    danger: {
      main: "#DC2626",
      hover: "#B91C1C",
    },

    warning: {
      main: "#E8A33D",
      hover: "#D8922E",
    },
  },

  gradient: {
    primary:
      "linear-gradient(90deg, rgba(10,10,15,1) 0%, rgba(24,18,10,1) 50%, rgba(10,10,15,1) 100%)",

    secondary:
      "linear-gradient(90deg, rgba(17,17,20,1) 0%, rgba(35,25,12,1) 50%, rgba(17,17,20,1) 100%)",

    accent: "linear-gradient(135deg, #E8A33D 0%, #F6C56F 100%)",
  },

  glow: {
    primary: "0 0 25px rgba(232, 163, 61, 0.35)",
    soft: "0 0 15px rgba(232, 163, 61, 0.2)",
    intense: "0 0 40px rgba(232, 163, 61, 0.40)",
  },
};
